'use client';
import { LayoutProvider } from '../layout/context/layoutcontext';
import { PrimeReactProvider } from 'primereact/api';
import React, { useState, useEffect } from 'react';


import { AuthProvider } from '../context/';

import { usePathname } from 'next/navigation'

import axios from 'axios';
import AuthStorage from '../storage/AuthStorage';
import AuthController from '../controller/AuthController';
import { Provider } from "react-redux";
import { verifySubdomainBase, verifyUser } from '../routes/ConfigSubdomain';
import { getConfigSubdomainDefault, GetCurrentUserDefault } from '../storage/getConfigSubdomainDefault';

import App from '../routes/App';

import '../assets/themes/primereact.css';
import 'primeicons/primeicons.css';
import '../styles/layout/layout.scss';
import '../styles/demo/Demos.scss';

import configureStore from "../store/configureStore";
const store = configureStore();


interface RootLayoutProps {
    children: React.ReactNode;
}

export default function RootLayout({ children }: RootLayoutProps) {

    const basePath = (process.env.NEXT_PUBLIC_BASE_PATH || "");

    const [dataConfigSubdomain, setDataConfigSubdomain] = useState(getConfigSubdomainDefault);
    let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit } = dataConfigSubdomain;




    const [authStorage, setAuthStorage] = useState(undefined);

    useEffect(() => {

        verifySubdomainBase();

        const authStorage = new AuthStorage(window.location.pathname);
        let mewdataConfigSubdomain = authStorage.getConfigSubdomain();

        setDataConfigSubdomain(mewdataConfigSubdomain);

        subdomain = mewdataConfigSubdomain.subdomain;
        idSuscripcion = mewdataConfigSubdomain.idSuscripcion;
        idEmpresaInit = mewdataConfigSubdomain.idEmpresaInit;
        idiomaInit = mewdataConfigSubdomain.idiomaInit;

    }, []);


    // For GET requests
    axios.interceptors.request.use(

        (config) => {

            //console.log("interceptors.request.use");
            const authStorage = new AuthStorage(window.location.pathname);
            const userDetails = authStorage.GetCurrentUser();
            
            const { token } = userDetails;

            if (config.headers['Authorization'] !== "multipart/form-data") {
                config.headers['Content-Type'] = "application/json";
            }

            config.headers['Authorization'] = `Bearer ${token}`;
            config.withCredentials = true;

            config.headers['Access-Control-Allow-Origin'] = "*";
            config.headers['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';
            //config.headers['Access-Control-Allow-Credentials'] = "true";
            config.headers['Access-Control-Allow-Headers'] = "x-access-token, X-Version, Origin, X-Requested-With, Content-Type, Accept";

            config.withCredentials = true;
            config.validateStatus = (status) => {
                //console.log("validateStatus, ",status);
                return true; // I'm always returning true, you may want to do it depending on the status received
            }

            return config;
        },

        (req) => {
            // Add configurations here
            console.log("Solicitud", req);

            return req;
        },
        (err) => {
            console.log("entró por acá");
            return Promise.reject(err);
        }
    );

    // For POST requests
    axios.interceptors.response.use(

        (res) => {

            let nameHeaderVersion = "x-version";
            let appVersionAPI = res.headers[nameHeaderVersion];
            let reactAPPVersion = process.env.NEXT_PUBLIC_VERSION || "";

            //console.log("res.headers['x-version'],", appVersionAPI, "process.env.VERSION", reactAPPVersion);

            const authStorage = new AuthStorage(window.location.pathname);

            authStorage.setIdleTime(0);

            if (appVersionAPI > reactAPPVersion) { // if server version newer
                authStorage.setVersionUpdateNeeded('true'); // set version update item so can refresh app later
            };

            //console.log("entró por acá2222", res);

            // Add configurations here
            if (res.status === 201) {
                console.log('Posted Successfully');
            }
            else if (res.status === 401) {
                console.log('No autorizado');
            }

            return res;
        },
        (err) => {
            //let CodeHttpErrorUnauthorized = "401";f
            // let error401= err.includes("401");

            console.log("error extraño", Object.keys(err), err.response, err.isAxiosError);
            const authController = new AuthController();

            const hayConexion = authController.VerifyConexion() || false;

            if (!hayConexion) {
                console.log("Se detecta que el API no  responde");
                return Promise.reject("Se detecta que el API no  responde");
            }

            if (err.response) {
                console.log("err.response, ", err.response.status);
            }


            if (hayConexion) {
                const authStorage = new AuthStorage(window.location.pathname);
                const userDetails = authStorage.GetCurrentUser();

                const { userName, sessionGUID } = userDetails;

                const tokenPayload = { userName: userName, sessionGUID: sessionGUID };

                let response = authController.GetTokenAutorization(tokenPayload);
                return axios.request(err.config);

            }

            return Promise.reject(err);
        }
    );

    console.log("layout_undefined, ", typeof window !== 'undefined');

    console.log("RootLayout,", 121);

    let typeofwindow = typeof window !== 'undefined';

    if (typeofwindow && idSuscripcion > 0) {

        //let domainConfigured = verifySubdomainBase();

        //let dataConfigSubdomain = authStorage.getConfigSubdomain();
        //let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit, urlLogoMenu } = dataConfigSubdomain;


        return (
            <html lang="en" suppressHydrationWarning>
                <head>
                    <link id="theme-css" href={basePath + "/themes/lara-light-indigo/theme.css"} rel="stylesheet"></link>
                    <link id="theme-css" href={basePath + "/themes/primereact.css"} rel="stylesheet"></link>
                </head>
                <body>

                    <AuthProvider value={500}>

                        <PrimeReactProvider>
                            <Provider store={store}>
                                <App></App>
                            </Provider>
                        </PrimeReactProvider>
                    </AuthProvider>

                </body>
            </html>
        );
    }
    else if (true) {

        return (
            <html lang="en" suppressHydrationWarning>
                <head>
                    <link id="theme-css" href={basePath + "/themes/lara-light-indigo/theme.css"} rel="stylesheet"></link>
                    <link id="theme-css" href={basePath + "/themes/primereact.css"} rel="stylesheet"></link>
                </head>
                <body>
                    <AuthProvider value={500}>
                        <PrimeReactProvider>
                            <Provider store={store}>
                                ...cargando...
                            </Provider>
                        </PrimeReactProvider>
                    </AuthProvider>
                </body>
            </html>
        );
    }
    else {
        return (
            <html lang="en" suppressHydrationWarning>
                <head>
                    <link id="theme-css" href={basePath + "/themes/lara-light-indigo/theme.css"} rel="stylesheet"></link>
                </head>
                <body>
                    <AuthProvider value={500}>

                        <PrimeReactProvider>
                            <LayoutProvider>
                                <Provider store={store}>
                                    ...cargando...
                                </Provider>
                            </LayoutProvider>
                        </PrimeReactProvider>
                    </AuthProvider>
                </body>
            </html>
        );
    }

}
